import {FAILURE, PENDING, SUCCESS} from '../../constants'
import {getGroupFieldValues as getGroupFieldValuesAPI} from '../../../services/groups'

export async function getGroupFieldValues(dispatch, {group_id, field_id}) {
  try {
    dispatch({type: PENDING})

    let response = await getGroupFieldValuesAPI({group_id, field_id})

    dispatch({type: SUCCESS, payload: response, key: `${group_id}_${field_id}`})
  } catch (e) {
    console.log(`Get Group Field Values Failed: ${group_id} ${field_id}`, e)
    dispatch({type: FAILURE, payload: e})
  }
}
